import { Box, Typography, TextareaAutosize, TextField, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState } from "react";
import { entrySchema } from '../Validations/entry_validation';
import { getErrors } from '../util/validation_utilities';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../util/axios_instance';


function NewEntry() {
    const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;
    const navigate = useNavigate();
    const location = useLocation();
    const { journal_id, journal_title } = location.state || {}; // Safe access in case state is undefined
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        journalId: journal_id,
        title: '',
        data: ''
    })

    const handleChange = (event) => {

        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const saveJournal = async (e) => {
        let response;
        e.preventDefault();
        try {
            await entrySchema.validate(formData, { abortEarly: false })
            setErrors({});
            response = await axiosInstance.post(`${BACKEND_HOST}/journal/create_entry`, formData, {
                withCredentials: true
            })
        } catch (validationErrors) {
            setErrors(getErrors(validationErrors));
        } finally {
            if (response && response.status === 200) {
                navigate('/journal_entries', { state: { journal_id, journal_title } });
            }
        }
    }

    return (
        <div>
            <form onSubmit={saveJournal}>
                <Box display="flex"
                    flexDirection={"column"}
                    maxWidth={1024} alignItems={'center'}
                    width="50vw" // Set width to 50% of the viewport width
                    justifyContent={'center'}
                    margin={'auto'}
                    marginTop={5}
                    padding={3}
                    borderRadius={5}
                    boxShadow={"5px 10px 10px #ccc"}
                    sx={{
                        ":hover": {
                            boxShadow: "10px 10px 20px #ccc",
                        }
                    }}>
                    <Typography variant='h2' padding={3} textAlign={'center'}>{journal_title}</Typography>

                    <TextField
                        margin='normal'
                        type='text'
                        variant='outlined'
                        name='title'
                        placeholder='Title'
                        value={formData.journalTitle}
                        onChange={handleChange}></TextField>
                    {errors.title && <div style={{ color: 'red' }}>{errors.title}</div>}
                    <TextareaAutosize
                        margin='normal'
                        type='text'
                        variant='outlined'
                        name='data'
                        placeholder='Journal Data'
                        value={formData.journalTitle}
                        minRows={15}
                        style={{ minWidth: 300 }}
                        onChange={handleChange}></TextareaAutosize>
                    {errors.data && <div style={{ color: 'red' }}>{errors.data}</div>}
                    <Button type='submit' sx={{ marginTop: 3, borderRadius: 3 }} variant='contained'>Save Journal</Button>
                </Box>
            </form>
        </div>)
}

export default NewEntry;